import { isGuestRole } from "./emailVerification";

/**
 * Retail UI (cart, lists, checkout) for real customers, or for admins in
 * "תצוגת לקוח" (isClientView). Staff overlays stay keyed on role separately.
 */
export const canUseCustomerFeatures = (
  role,
  isClientView = false,
  user = null,
) => {
  if (!user || isGuestRole()) return false;
  if (!role) return true;
  return Boolean(isClientView);
};
